import { polyfill } from 'smoothscroll-polyfill'

export default defineNuxtPlugin(() => {
  // kick off the polyfill!
  if (import.meta.client) { polyfill() }
})
